export default {"src":"/_next/static/media/abseiling.9a364eaa.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};